import { Stack } from "types/generated";
import { VENDOR_CONFIG_TYPENAME } from "constants/vendor";

export const isAnsibleStackVendor = (stack: Partial<Stack>) =>
  stack?.vendorConfig?.__typename === VENDOR_CONFIG_TYPENAME.ANSIBLE;
